import { forwardRef } from 'react';
import { Table, TableColumnsType } from 'antd';
import { roundAndFormat } from '../../../lib/utils';
import CustomDescriptionItem from '../../../components/CustomDescriptionItem';
import { OrderLine, PurchaseOrderInfo } from '../../../types/PurchaseOrder';

interface PurchaseOrderPrintTemplateProps {
  data?: PurchaseOrderInfo;
}

const PurchaseOrderPrintTemplate = forwardRef<
  HTMLDivElement,
  PurchaseOrderPrintTemplateProps
>(({ data }, ref) => {
  const columns: TableColumnsType<OrderLine> = [
    {
      title: 'Product',
      dataIndex: 'name',
      render: (_text, record) => <span>{record.product.description}</span>,
    },
    {
      title: 'Code',
      dataIndex: 'productCode',
      render: (_text, record) => <span>{record.product.code}</span>,
    },
    {
      title: 'Product UoM',
      dataIndex: 'uom',
      render: (_text, record) => <span>{record.productUom.description}</span>,
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      render: (_text, record) => <span>{roundAndFormat(record.quantity)}</span>,
    },
    {
      title: 'Unit Price',
      dataIndex: 'unitPrice',
    },
    {
      title: 'Total Amount',
      dataIndex: 'totalAmount',
      render: (_text, record) => (
        <span>{roundAndFormat(record.quantity * record.unitPrice)}</span>
      ),
    },
  ];

  const subtotal = data?.orderLines.reduce(
    (acc, curr) => acc + curr.quantity * curr.unitPrice,
    0,
  );
  const formattedSubtotal = subtotal?.toLocaleString('en-US', {
    style: 'currency',
    currency:
      data?.currency === undefined || data?.currency === null
        ? 'USD'
        : data?.currency,
  });

  return (
    <div ref={ref}>
      <div className={'p-4 items-center justify-center'}>
        <div className={'flex items-center justify-between pb-3'}>
          <div className={'flex'}>
            <img src={'/mmd/mmd.png'} alt={'mmd.png'} className={'w-10 h-10'} />
            <span className={'font-semibold text-2xl'}>
              Asia Ceramic Corporation
            </span>
          </div>
          <span className={'font-semibold text-2xl'}>Purchase Order</span>
        </div>
        <div>
          <div className="flex flex-row justify-between mb-2">
            <CustomDescriptionItem
              label={'Purchase Order'}
              content={data?.code}
            />
            <CustomDescriptionItem
              label={'Order Date'}
              content={data?.orderDate}
            />
          </div>
          <div className="flex flex-row justify-between mb-2">
            <CustomDescriptionItem
              label={'Vendor name'}
              content={data?.vendor?.description}
            />
            <CustomDescriptionItem
              label={'Destination'}
              content={data?.destination?.description}
            />
          </div>
          <div className="flex flex-row justify-between mb-2">
            <CustomDescriptionItem label={'Address of Vendor'} content={'--'} />
            <CustomDescriptionItem label={'D.R Number'} content={''} />
          </div>
          <div className="flex justify-end">
            <CustomDescriptionItem
              label={'Terms'}
              content={data?.terms?.description}
            />
          </div>
        </div>
        <div>
          <Table
            rowKey={(record) => record.id}
            dataSource={data?.orderLines}
            columns={columns}
            pagination={false}
            footer={() => (
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <p style={{ marginRight: '12px', fontWeight: 'bold' }}>
                  Subtotal: {formattedSubtotal}
                </p>
              </div>
            )}
          />
        </div>
        <div className={'w-3/4'}>
          <CustomDescriptionItem label={'Remarks'} content={data?.notes} />
        </div>
        <div className="flex flex-row items-center justify-between">
          <div className="basis-1/4">
            <div className="flex flex-col">
              <div className="flex-1 w-full">
                <label>Prepared By</label>
              </div>
              <div className="flex-1 w-full border-b border-solid border-black">
                { data?.createdBy || (<span>&nbsp;</span>) }
              </div>
              <div className="flex-1 w-full">
                <i>Purchasing Staff</i>
              </div>
            </div>
          </div>
          <div className="basis-1/4">
            <div className="flex flex-col">
              <div className="flex-1 w-full">
                <label>Approved By:</label>
              </div>
              <div className="flex-1 w-full border-b border-solid border-black">
                { data?.approvedBy || (<span>&nbsp;</span>) }
              </div>
              <div className="flex-1 w-full">
                <i>Purchasing Head</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

{/* <div className="container flex pt-14 items-center justify-between px-12">
<div className="mr-8">
  <p>Prepared By:</p>
  <div className="border-b border-solid border-black w-[200px]">
  {data?.createdBy || (<>&nbsp;</>)}
  </div>
  <p className="text-xs">
    <i>Purchasing Staff</i>
  </p>
</div>

<div className="mr-8">
  <p>Approved By:</p>
  <div className="border-b border-solid border-black w-[200px]">
    {data?.approvedBy || (<>&nbsp;</>)}
  </div>
  <p className="text-xs">
    <i>Purchasing Head</i>
  </p>
</div>
</div> */}
PurchaseOrderPrintTemplate.displayName = 'PurchaseOrderPrintTemplate';

export default PurchaseOrderPrintTemplate;
